import { Link } from "react-router-dom";
import { Facebook, Linkedin, Mail, Phone, MapPin } from "lucide-react";

const socials = [
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/coresureoutsourcing" },
  { icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/company/71506340/" },
];

export const Footer = () => (
  <footer className="bg-[#0A0A0A] text-white border-t border-[#27272A]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-8 h-8 bg-[#FF5A00] flex items-center justify-center font-heading font-extrabold text-white text-lg">C</span>
            <span className="font-heading font-extrabold tracking-tight text-lg">CORE SURE BUSINESS SERVICES PRIVATE LIMITED</span>
          </div>
          <p className="text-zinc-400 text-sm leading-relaxed max-w-md">
            Trusted bookkeeping, accounting, accounts payable and accounts receivable services for businesses across the USA and Canada. Accurate books, on time, every time — starting at just $9.99/hour.
          </p>
          <div className="flex gap-3 mt-6">
            {socials.map(({ icon: Icon, label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${label.toLowerCase()}`}
                aria-label={label}
                className="w-10 h-10 border border-[#27272A] flex items-center justify-center hover:bg-[#FF5A00] hover:border-[#FF5A00] transition-colors"
              >
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-widest text-zinc-500 mb-4">Quick Links</h4>
          <ul className="space-y-2.5 text-sm">
            {[
              ["Home", "/"],
              ["About Us", "/about"],
              ["Services", "/services"],
              ["Pricing", "/pricing"],
              ["Blog", "/blog"],
              ["Book Appointment", "/appointment"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-zinc-400 hover:text-[#FF5A00] transition-colors">{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-widest text-zinc-500 mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li>
              <a href="mailto:info@coresure.us" data-testid="footer-email-link" className="flex items-start gap-2 hover:text-[#FF5A00] transition-colors">
                <Mail size={16} className="mt-0.5 text-[#FF5A00]" /> info@coresure.us
              </a>
            </li>
            <li>
              <a href="https://wa.me/919034950501" target="_blank" rel="noopener noreferrer" data-testid="footer-phone-link" className="flex items-start gap-2 hover:text-[#FF5A00] transition-colors">
                <Phone size={16} className="mt-0.5 text-[#FF5A00]" /> +91-9034950501 (WhatsApp)
              </a>
            </li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-[#FF5A00]" /> Serving USA &amp; Canada</li>
          </ul>
          <a
            href="https://www.blogger.com/blog/posts/237350172922570442"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-blogger-link"
            className="inline-block mt-6 border border-[#FF5A00] text-[#FF5A00] text-xs font-bold uppercase tracking-widest px-4 py-2.5 hover:bg-[#FF5A00] hover:text-white transition-colors"
          >
            Our Blogger Page
          </a>
        </div>
      </div>

      <div className="border-t border-[#27272A] mt-12 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-zinc-500">
        <span>© {new Date().getFullYear()} Core Sure Business Services Private Limited · coresure.us · All rights reserved.</span>
        <span className="font-mono-price">Bookkeeping from $9.99/hr · 1 Week Free Trial</span>
      </div>
    </div>
  </footer>
);
